var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "appsumo-page__wrapp" }, [
      _c("div", { staticClass: "appsumo-page__container" }, [
        _c("img", {
          staticClass: "appsumo-page__logo",
          attrs: { src: "/img/logo_appsumo_ss.png", alt: "" },
        }),
        _c("h1", { staticClass: "appsumo-page__title" }, [
          _vm._v("Hello Sumo-ling! 👋"),
        ]),
        _c("div", { staticClass: "appsumo-deal-over" }, [
          _c("p", [_vm._v("Sorry, AppSumo codes can’t be redeemed anymore")]),
          _c("div", { staticClass: "appsumo-deal-over-details" }, [
            _vm._v("\n        According to our "),
            _c(
              "a",
              {
                attrs: {
                  target: "_blank",
                  href: "https://appsumo.com/products/spreadsimple/#pricePlans",
                },
              },
              [_vm._v("AppSumo Deal Terms and Conditions")]
            ),
            _vm._v(
              ", after you’ve purchased a code, you must have redeemed it within 60 days.\n        We understand that sometimes 2 months is not enough that’s why we made it 10 months for you to redeem your codes as a thank you for your interest in SpreadSimple and your support.\n        But, unfortunately, all things must come to an end, and all our codes have expiration dates as well.\n        Due to the fact that it’s been almost a year since our last AppSumo Deal has officially ended, all the codes that were not redeemed before "
            ),
            _c("b", [_vm._v("November 25th, 2022")]),
            _vm._v(
              " are no longer valid.\n        If you have any questions or concerns regarding the expired deal, please reach out to AppSumo Support team at "
            ),
            _c("a", { attrs: { href: "mailto:support@appsumo.com" } }, [
              _vm._v("support@appsumo.com"),
            ]),
            _vm._v(".\n      "),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }